import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { useState, useEffect } from "react";
import MainLayout from "../layouts/MainLayout";
import Home from "../pages/Home";
import ChatbotMain from "../pages/ChatbotMain";
import Login from "../pages/Auth/Login";
import Mfa from "../pages/Auth/Mfa";
import ForgotPassword from "../pages/Auth/ForgotPassword";
import SignUp from "../pages/Auth/SignUp";
import Docs from "../pages/Docs";
import AdminDashboard from "../pages/AdminDashboard";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsOfService from "../pages/TermsOfService";

// 🔒 ProtectedRoute wrapper
function ProtectedRoute({ children }) {
  const token = localStorage.getItem("token");
  return token ? children : <Navigate to="/" replace />;
}

// ⚡ Wrapper to get location and inject `key` into Home
function RoutedHome({ theme, setTheme }) {
  const location = useLocation();

  return (
    <ProtectedRoute>
      <MainLayout theme={theme} setTheme={setTheme}>
        <Home key={location.state?.refresh || "home"} />
      </MainLayout>
    </ProtectedRoute>
  );
}

export default function AppRouter({ theme, setTheme }) {
  const [currentTheme, setCurrentTheme] = useState(
    localStorage.getItem("theme") || theme || "light"
  );

  useEffect(() => {
    if (currentTheme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
    localStorage.setItem("theme", currentTheme);
  }, [currentTheme]);

  return (
    <Router>
      <Routes>
        {/* Auth Routes (Public) */}
        <Route
          path="/"
          element={<Login theme={currentTheme} setTheme={setCurrentTheme} />}
        />
        <Route
          path="/mfa"
          element={<Mfa theme={currentTheme} setTheme={setCurrentTheme} />}
        />
        <Route
          path="/forgot-password"
          element={
            <ForgotPassword theme={currentTheme} setTheme={setCurrentTheme} />
          }
        />
        <Route
          path="/signup"
          element={<SignUp theme={currentTheme} setTheme={setCurrentTheme} />}
        />
        <Route
          path="/privacy"
          element={
            <PrivacyPolicy theme={currentTheme} setTheme={setCurrentTheme} />
          }
        />
        <Route
          path="/termsofservice"
          element={
            <TermsOfService theme={currentTheme} setTheme={setCurrentTheme} />
          }
        />
        {/* Protected/Main Layout Routes */}
        <Route
          path="/home"
          element={
            <RoutedHome theme={currentTheme} setTheme={setCurrentTheme} />
          }
        />
        <Route
          path="/chatbot/:chatbotId?"
          element={
            <ProtectedRoute>
              <MainLayout theme={currentTheme} setTheme={setCurrentTheme}>
                <ChatbotMain />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/doc"
          element={
            <ProtectedRoute>
              <MainLayout theme={currentTheme} setTheme={setCurrentTheme}>
                <Docs />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <MainLayout theme={currentTheme} setTheme={setCurrentTheme}>
                <AdminDashboard />
              </MainLayout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}
